import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

type TooltipDivProps = {
    width: number | undefined,
}

export const ReactTooltipWithoutArrow = styled(ReactTooltip)`
    border: 6px solid #222;
    padding: 8px 11px;
    font-size: 13px;
    line-height: 20px;
`;

export const TooltipDiv = styled.div<TooltipDivProps>`
    width: ${({ width }) => width}px;
`;

export const TooltipText = styled.span`
    font-weight: bold;
`;

export const Icon = styled(FontAwesomeIcon)<FontAwesomeIconProps>`
    font-size: 12px;
    margin-right: 5px;
    padding-bottom: 2px;
`;
